import { data } from '../../svg/Purpose/data';
import { makeIcon } from '../makeIcon';

export const Purpose = makeIcon(data, 'purpose', 'Purpose');

export default Purpose;
